<div class="confirmationModal">
    <app-custom-otp [otpBox]="data.otpBox" [isSubmitBtn]="data.isSubmitBtn" [showCloseIcon]="data.showCloseIcon"
        (sendOtp)="sendOtp($event)" [title]="data.title" (closeTemplateModal)="closeTemplateModal()"
        [message]="data.message" (resendOtp)="resendOtp()" [submitBtnName]="data.submitBtnName"
        [submitBtnClass]="data.submitBtnClass">
    </app-custom-otp>
</div>